<template>
    <v-container>
        <v-toolbar rounded="" color="secondary" dense class="mb-3" elevation="1">
            <v-breadcrumbs class="ms-n6" :items="[{text: 'Settings'}, {text: 'Payment Accounts'}]" large/>
        </v-toolbar>
        <v-sheet elevation="1">
            <v-toolbar flat color="secondary">
                <v-toolbar-title>
                    Payment Modes
                </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <PurchasePaymentModeList/>
        </v-sheet>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PurchasePaymentModeList from './../../components/purchase/PurchasePaymentModeList.vue';

export default {
    name: "PurchasePaymentModeListView",
    components: {
        PurchasePaymentModeList,
    },
    data() {
        return {
            perm: permissions
        }
    }
}
</script>

<style>

</style>